import React, { useState, useEffect } from "react";
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import { Checkbox } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import axios from "../../../security/axios";
import { useAcceptJs } from "react-acceptjs";
import "../OrderManager.css";
import NotificationBar from "../../../components/notification-bar/NotificationBar";
import 'react-phone-number-input/style.css'
import PhoneInput from "react-phone-number-input/input";
import { parsePhoneNumber, getCountryCallingCode } from 'react-phone-number-input'


const CreateNewOrder = (props) => {

    console.log(props);

    var authData = {};
    const environment = "PRODUCTION";
    if(props.merchant == 1) {
            //TA Authorize.net
            //OLD ClientKey: '8Y7r9c7VRVzxEQHR54D4c5yRe9Sn5L5TVc2tj9jpTMNr6yVV8vgYgDLw7U5Dr3G6'
            /*authData = {
                apiLoginID: '2F5TnH8eRq',
                clientKey: '97ZT868sK747S4yXRBcPGQjD6Ce3eeZ624yFzx6W7c5PDkEB5X9erqxF3Kxra2dX',
            };*/

            
            //Auth.net (George)
            console.log('MERCHANT 1');
            authData = {
                apiLoginID: '2FbVc53kk',
                clientKey: '4BfEC4cH6UgUPu77vrP4AjbKk8WuQNC36233QpcmtbfUuxSpjpyLpsvm987PHPmv'
            };
        } else {
            //TrdersAgency #2
            /*authData = {
                apiLoginID: '564PmD2FvhL',
                clientKey: '7jf2zS832EYqGZf225GmV6G8nZxCK2Ku7sZp9Zg4eNKz44K77aVbQh63QwtR7JyP'
            };*/
            //TA Authorize.net
            console.log('MERCHANT 2');
            authData = {
                apiLoginID: '2F5TnH8eRq',
                clientKey: '97ZT868sK747S4yXRBcPGQjD6Ce3eeZ624yFzx6W7c5PDkEB5X9erqxF3Kxra2dX',
            };
        }
    
    const { dispatchData, loading, error } = useAcceptJs({ environment, authData });
    console.log(environment, authData);

    var productOptions = [];

    const [allProducts, setAllProducts] = useState([]);

    const [updating, setUpdating] = useState(false);
    const [firstName, setFName] = useState("");
    const [lastName, setLName] = useState("");
    const [emailAddress, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [productId, setProduct] = useState("");
    const [salesPrice, setPrice] = useState("");
    const [splitPay, setSplitPay] = useState(false);
    const [subscription, setSubscription] = useState(false);
    const [installments, setInstallments] = useState("");
    const [installmentPrice, setInstallmentPrice] = useState("");
    const [subscriptionFrequency, setFrequency] = useState("");
    const [subscriptionFrequencyPeriod, setFrequencyPeriod] = useState("");
    const [perpetualSubscription, setPerpetualSubscription] = useState(true);
    const [cycleNumber, setCycleNumber] = useState("");
    const [nameOnCard, setNameOnCard] = useState("");
    const [creditCardNumber, setNumber] = useState("");
    const [creditCardDate, setDate] = useState("");
    const [creditCardCSV, setCSV] = useState("");
    const [ipData, setIpData] = useState("");
    //const [merchant, setMerchant] = useState(1);

    async function fetchProducts() {
        const getProducts = await
            console.log(getProducts.data);
    }

    async function setPhoneDetails(phoneNumb) {
        const parseNum = parsePhoneNumber(phoneNumb);
        console.log(parseNum);
        setPhone(phoneNumb);
        setPhoneNumber(parseNum.nationalNumber);
        setCountryCode(parseNum.countryCallingCode);
    }

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios.get(
                '/products',
            );

            setAllProducts(result.data);
        };

        (async () => {
            return await fetch('https://ipapi.co/json/', { method: 'GET' })
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        return {};
                    }
                })
        })().then(res => {
            console.log(res);
            setIpData(res);
        });

        fetchData();
    }, []);

    if (allProducts != []) {
        productOptions = allProducts.map((product) => {
            return {
                label: product.name,
                value: product.id,
                price: product.price
            }
        });
    }
    /*
        const onProductFind = async () => {
            const getProducts = await axios.get('/products');
            setAllProducts(getProducts.data);
            return allProducts;
        };
        onProductFind();
    */
    function changeInstallments(value) {
        setInstallments(value);
        setInstallmentPrice(salesPrice / value);
    }



    const recurringIncrements = [
        { label: "Day(s)", value: "day" },
        { label: "Month(s)", value: "month" },
        { label: "Year(s)", value: "year" }
    ];

    const merchants = [
        { label: "Merchant 1", value: 1 },
        { label: "Merchant 2", value: 2 }
    ];



    const [notification, setNotification] = useState({
        message: '',
        severity: '',
    });


    async function OrderManagerSubmit(e) {
        console.log(e);
        e.preventDefault();
        //setUpdating(true);

        const dte = creditCardDate.split("-");
        const year = dte[0];
        const month = dte[1];



        const response = await dispatchData({
            cardData: {
                cardNumber: creditCardNumber,
                month: month,
                year: year,
                cardCode: creditCardCSV
            }
        });
        console.log(response);

        console.log("This is it!");

        const body = {
            first_name: firstName,
            last_name: lastName,
            email: emailAddress,
            phone_number: phoneNumber,
            country_code: countryCode,
            product_id: productId,
            price: salesPrice,
            cc_name: nameOnCard,
            cc_number: creditCardNumber.substr(-4),
            cc_date: creditCardDate,
            cc_csv: creditCardCSV,
            data_value: response.opaqueData.dataValue,
            cc_month: month,
            cc_year: year,
            ip_data: ipData
        };

        if (subscription == true) {
            body.subscription = 1;
            body.subscription_frequency = parseInt(subscriptionFrequency);
            body.frequency_type = subscriptionFrequencyPeriod;
            if (perpetualSubscription == true) {
                body.subscription_cycles = 'null';
            } else {
                body.subscription_cycles = parseInt(cycleNumber);
            }
        } else if (splitPay == true) {
            body.split_pay = 1;
            body.installments = installments;
            body.installment_price = installmentPrice;
        }

        const jsonObj = JSON.stringify(body);

        console.log(jsonObj);

        console.log(body);
        try {

            const result = await axios.post(`/create-order`, body);
            try {
                if (typeof result.data.response.data.transaction_id != "undefined") {
                    console.log(result);
                    alert("Transaction has been created with the id: " + result.data.response.data.transaction_id);
                } else if (typeof result.data.response.error != "undefined") {
                    console.log(result);
                    alert("Error: " + result.data.response.error);
                } else {
                    console.log(result);
                    alert("Error: " + result.data.response.errors[0]);
                }
            } catch (e) {
                console.log(e);
                alert("Error: " + result.data.response.errors[0])
            }


        } catch (e) {
            console.log(e);
            alert("Something went wrong internally, please contact IT.");
        }

    }

    return (
        <section>
            <div className="ml-1">
                <Typography variant="h5" className="ml-1">
                    Order Manager - Create Order
                </Typography>
            </div>
            {(notification.message) && (
                <NotificationBar notification={notification}
                    closeCallback={() => setNotification({
                        message: null,
                        severity: null,
                    })} />
            )}
            <div className="ml-1 mr-1 mt-50">
                <form onSubmit={OrderManagerSubmit}>
                    <div className="contact-section">
                        <Typography variant="body1" gutterBottom>
                            Contact Info:
                        </Typography>
                        <div className="mt-25 dual-input" >

                            <div className="form-input">
                                <input className="form-control" id="first_name" name="first_name" type="text" value={firstName} onChange={e => setFName(e.target.value)}
                                    placeholder="First Name *" tabindex="1" aria-required="true" />
                            </div>
                            <div className="form-input">
                                <input className="form-control" id="last_name" name="last_name" type="text" value={lastName} onChange={e => setLName(e.target.value)}
                                    placeholder="Last Name *" tabindex="1" aria-required="true" />
                            </div>
                        </div>
                        <div className="mt-25 dspl-inlblk">
                            <Typography variant="body1" gutterBottom>
                                Email Address:
                            </Typography>
                            <div>
                                <div className="mt-10 mb-50">
                                    <input className="w-100 contact-update-input"
                                        required
                                        type="email"
                                        value={emailAddress}
                                        onChange={e => setEmail(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="mt-25 dspl-inlblk">
                            <Typography variant="body1" gutterBottom>
                                Phone Number:
                            </Typography>
                            <div>
                                <div className="mt-10 mb-50">
                                    <PhoneInput className="w-100 contact-update-input"
                                        placeholder="Enter phone number"
                                        value={phone}
                                        onChange={value => setPhoneDetails(value)} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="contact-section">
                        <Typography variant="body1" gutterBottom>
                            Order Info:
                        </Typography>
                        <div className="mt-25 dspl-inlblk">
                            <Typography variant="body1" gutterBottom>
                                Product:
                            </Typography>
                            <div>
                                <div className="mt-10 mb-50">

                                    <Select className="w-300 contact-update-input"
                                        id="productDropdown"
                                        required
                                        options={productOptions}
                                        value={productOptions.filter(function (option) {
                                            return option.value === productId;
                                        })}
                                        onChange={e => {
                                            setProduct(e.value);
                                            setPrice(e.price);
                                            console.log(e);
                                        }} />

                                </div>
                            </div>
                        </div>
                        <div className="mt-25 dspl-inlblk">
                            <Typography variant="body1" gutterBottom>
                                Sales Price:
                            </Typography>
                            <div>
                                <div className="mt-10 mb-50">
                                    <CurrencyInput className="w-100 contact-update-input"
                                        required
                                        decimalsLimit={2}
                                        prefix="$"
                                        value={salesPrice}
                                        onValueChange={value => setPrice(value)} />
                                </div>
                            </div>
                        </div>
                        {subscription == false ? (
                            <div className="mt-25 dspl-inlblk">
                                <Typography variant="body1" gutterBottom>
                                    Split Pay:
                                </Typography>
                                <div>
                                    <div className="mt-10 mb-50">
                                        <Checkbox className="w-100 contact-update-input"
                                            type="checkbox"
                                            checked={splitPay == true}
                                            onChange={e => setSplitPay(e.target.checked)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {splitPay == false ? (
                            <div className="mt-25 dspl-inlblk">
                                <Typography variant="body1" gutterBottom>
                                    Subscription:
                                </Typography>
                                <div>
                                    <div className="mt-10 mb-50">
                                        <Checkbox className="w-100 contact-update-input"
                                            type="checkbox"
                                            checked={subscription == true}
                                            onChange={e => setSubscription(e.target.checked)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {splitPay == true ? (
                            <div className="mt-25 dspl-inlblk">
                                <Typography variant="body1" gutterBottom>
                                    Installments:
                                </Typography>
                                <div>
                                    <div className="mt-10 mb-50">
                                        <input className="w-100 contact-update-input"
                                            required
                                            type="number"
                                            min="2"
                                            value={installments}
                                            onChange={e => changeInstallments(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {splitPay == true ? (
                            <div className="mt-25 dspl-inlblk">
                                <Typography variant="body1" gutterBottom>
                                    Installments Price:
                                </Typography>
                                <div>
                                    <div className="mt-10 mb-50">
                                        <CurrencyInput className="w-100 contact-update-input"
                                            required
                                            decimalsLimit={2}
                                            prefix="$"
                                            value={installmentPrice}
                                            onChange={value => setInstallmentPrice(value)} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {subscription == true ? (
                            <div className="mt-25 dspl-inlblk">
                                <Typography variant="body1" gutterBottom>
                                    Subscription Frequency:
                                </Typography>
                                <div>
                                    <div className="mt-10 mb-50">
                                        Every
                                        <input className="w-100 contact-update-input"
                                            required
                                            type="number"
                                            min="1"
                                            value={subscriptionFrequency}
                                            onChange={e => setFrequency(e.target.value)} />
                                        <Select className="w-100 contact-update-input"
                                            id="SubscriptionFrequencyPeriod"
                                            required
                                            options={recurringIncrements}
                                            value={recurringIncrements.filter(function (option) {
                                                return option.value === subscriptionFrequencyPeriod;
                                            })}
                                            onChange={e => setFrequencyPeriod(e.value)} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {subscription == true ? (
                            <div className="mt-25 dspl-inlblk">
                                <Typography variant="body1" gutterBottom>
                                    Perpetual Subscription:
                                </Typography>
                                <div>
                                    <div className="mt-10 mb-50">
                                        <Checkbox className="w-100 contact-update-input"
                                            type="checkbox"
                                            checked={perpetualSubscription == true}
                                            onChange={e => setPerpetualSubscription(e.target.checked)}
                                        />
                                    </div>
                                </div>
                            </div>) : null
                        }
                        {perpetualSubscription == false ? (
                            <div className="mt-25 dspl-inlblk">
                                <Typography variant="body1" gutterBottom>
                                    Number of Cycles:
                                </Typography>
                                <div>
                                    <div className="mt-10 mb-50">
                                        <input className="w-100 contact-update-input"
                                            required
                                            type="number"
                                            max="12"
                                            min="1"
                                            value={cycleNumber}
                                            onChange={e => setCycleNumber(e.target.value)} />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {
                            /*
                        <div className="mt-25 dspl-inlblk">
                            <Typography variant="body1" gutterBottom>
                                Merchant:
                            </Typography>
                            <div>
                                <div className="mt-10 mb-50">
                                    <Select className="w-100 contact-update-input"
                                        id="Merchant"
                                        required
                                        options={merchants}
                                        value={merchants.filter(function (option) {
                                            return option.value === merchant;
                                        })}
                                        onChange={e => setMerchant(e.value)} />
                                </div>
                            </div>
                        </div>
                                    */}

                    </div>

                    <div className="contact-section">
                        <Typography variant="body1" gutterBottom>
                            Card Info:
                        </Typography>
                        <div className="mt-25 dspl-inlblk">
                            <Typography variant="body1" gutterBottom>
                                Name on Card:
                            </Typography>
                            <div>
                                <div className="mt-10 mb-50">
                                    <input className="w-100 contact-update-input"
                                        required
                                        autoComplete="false"
                                        type="text"
                                        value={nameOnCard}
                                        onChange={e => setNameOnCard(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="mt-25 dspl-inlblk">
                            <Typography variant="body1" gutterBottom>
                                Credit Card Number:
                            </Typography>
                            <div>
                                <div className="mt-10 mb-50">
                                    <input className="w-100 contact-update-input creditcardnumber"
                                        required
                                        autoComplete="false"
                                        inputmode="numeric"
                                        pattern="[\d ]{10,30}"
                                        value={creditCardNumber}
                                        onChange={e => setNumber(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="mt-25 dspl-inlblk">
                            <Typography variant="body1" gutterBottom>
                                Expiration Date:
                            </Typography>
                            <div>
                                <div className="mt-10 mb-50">
                                    <input className="w-100 contact-update-input"
                                        required
                                        autoComplete="false"
                                        type="month"
                                        value={creditCardDate}
                                        onChange={e => setDate(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="mt-25 dspl-inlblk">
                            <Typography variant="body1" gutterBottom>
                                CVV:
                            </Typography>
                            <div>
                                <div className="mt-10 mb-50">
                                    <input className="w-100 contact-update-input"
                                        required
                                        autoComplete="false"
                                        inputmode="numeric"
                                        maxlength="4"
                                        value={creditCardCSV}
                                        onChange={e => setCSV(e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-75 mb-10">
                        <div>
                            <button type="submit" className="button save-btn accent" disabled={updating}>
                                Submit
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
};


export default CreateNewOrder;
